(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/joker-utils.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/joker-utils.js');
"use strict";

var _svs$numbergames$rule;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const productMapping = svs.numbergames.productMapping;
const config = (_svs$numbergames$rule = svs.numbergames.rules.data) === null || _svs$numbergames$rule === void 0 ? void 0 : _svs$numbergames$rule.config;
const JOKER_WINPLAN_DATA = {
  2: 40,
  3: 80,
  4: 500,
  5: 10000,
  6: 100000,
  7: 10000000
};

const isNewRules = _ref => {
  var _config$joker$ruleCha, _config$joker;
  let drawNumber = _ref.drawNumber,
    product = _ref.product;
  if (!drawNumber || !product) {
    svs.numbergames.rules.logger.debug('Drawnumber or product is missing');
    return false;
  }
  const _ref2 = (_config$joker$ruleCha = config === null || config === void 0 || (_config$joker = config.joker) === null || _config$joker === void 0 ? void 0 : _config$joker.ruleChange) !== null && _config$joker$ruleCha !== void 0 ? _config$joker$ruleCha : {},
    ONSJOKER = _ref2.ONSJOKER,
    LORJOKER = _ref2.LORJOKER;
  if (!ONSJOKER || !LORJOKER) {
    return false;
  }
  switch (true) {
    case productMapping.isJokerWednesday(product) && drawNumber >= ONSJOKER:
    case productMapping.isJokerSaturday(product) && drawNumber >= LORJOKER:
      return true;
    default:
      return false;
  }
};

function getJokerWinPlanData(jokerPrice) {
  return Object.fromEntries(Object.entries(JOKER_WINPLAN_DATA).map(_ref3 => {
    let _ref4 = _slicedToArray(_ref3, 2),
      correct = _ref4[0],
      amount = _ref4[1];
    return [correct, amount * jokerPrice / 10];
  }));
}
Object.assign(svs.numbergames.rules.utils.joker, {
  isNewRules,
  getJokerWinPlanData
});

 })(window);